import DPRForm from "src/components/feature/DigitaDPR/DPRForm";

const DPRFormPage = () => {
  return <DPRForm />;
};

export default DPRFormPage;
